import React, { Component } from 'react';
import { DLModal, LoadingOverlay } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import moment from 'moment-timezone';
import style from './styles/style.module.css';

import StepLink from './StepLink';
import StepVideoEdit from './StepVideoEdit';
import StepScheduleEdit from './StepScheduleEdit';


class BlockWizard extends Component {
    state = {
        step: 'video_uri',
        block: { should_persist: true },
        video: {},
        fetching: false,
    }
    componentDidUpdate( prevProps ) {
        if( !this.props.visible && prevProps.visible ) {
            this.setState( {
                step: 'video_uri',
                block: { should_persist: true },
                video: {},
                fetching: false,
            } );
        }
    }
    submitStepLink = ( data ) => {
        let blockData = { ...this.state.block };
        let videoData = { ...this.state.video };

        blockData.run_date = this.props.run_date;
        videoData.uri = data.value.uri;
        videoData.source = data.value.source;

        var runDate = moment.tz( this.props.run_date, 'MM/DD/YYYY', 'America/Chicago' );

        this.setState( { fetching: true } );

        if( data.next === 'next' && data.id ) {
            // we have a normal link, go get the deets on it
            dAPI.get( '/admin/dltv/video-details', { id: data.id } )
            .then( ( { videos } ) => {
                if( videos.length == 0 ) {
                    // TODO: throw an error here
                    return false;
                }
                var video = videos[ 0 ];
                video.liveStreamingDetails = video.liveStreamingDetails || {};

                videoData.title = video.snippet.title;
                videoData.duration = video.contentDetails.duration;
                videoData.description = video.snippet.description;
                videoData.cover_image = video.snippet.thumbnails.maxres ? video.snippet.thumbnails.maxres.url : video.snippet.thumbnails.standard.url;
                videoData.pro_name = video.snippet.channelTitle;
                videoData.is_live = video.liveStreamingDetails.liveBroadcastContent && video.liveStreamingDetails.liveBroadcastContent !== 'none';

                if( videoData.is_live ) {
                    let st = moment( video.liveStreamingDetails.scheduledStartTime ).years( runDate.years() ).dayOfYear( runDate.dayOfYear() );
                    blockData.start_time = st.format();
                    blockData.end_time = st.add( 1, 'hour' ).format();
                } else {
                    let st = moment().years( runDate.years() ).dayOfYear( runDate.dayOfYear() );
                    blockData.start_time = st.format();
                    blockData.end_time = st.add( moment.duration( videoData.duration ) ).add( 1, 'minute' ).seconds( 0 ).format();
                }

                this.setState( {
                    block: blockData,
                    video: videoData,
                    fetching: false,
                    step: 'edit_video',
                } );
            } )
            .catch( ( err ) => {
                // failed to retrieve video information
                console.warn( err );
                videoData.title = '';
                videoData.duration = 'P0D';
                videoData.description = '';
                videoData.cover_image = undefined;
            } );
        } else {
            // we don't have a normal link, see what we can do
        }
    }
    submitVideoEdit = ( data ) => {
        let blockData = {
            ...this.state.block,
            ...data.block,
        };
        let videoData = {
            ...this.state.video,
            ...data.video,
        };

        this.setState( {
            block: blockData,
            video: videoData,
            step: 'edit_schedule',
        } );
    }
    submitScheduleEdit = ( data ) => {
        if( data === false ) {
            this.setState( { step: 'edit_video' } );
            return;
        }
        this.setState( { fetching: true } );

        let blockData = {
            ...this.state.block,
            ...data.block,
        };
        let videoData = {
            ...this.state.video,
            ...data.video,
        };

        this.props.onSubmit( 'creating', {
            ...blockData,
            video: videoData,
        } );
    }



    render() {
        const { step } = this.state;
        return (
            <DLModal title='Block Wizard' className={ style.blockModal }
            visible={ this.props.visible }
            closeHandler={ this.props.closeHandler }>
                <div className={ style.content }>
                    <StepLink onSubmit={ this.submitStepLink }
                    step={ step } />

                    <StepVideoEdit onSubmit={ this.submitVideoEdit }
                    step={ step }
                    initialValues={ {
                        ...this.state.block,
                        ...this.state.video,
                    } } />
                    <StepScheduleEdit onSubmit={ this.submitScheduleEdit }
                    step={ step }
                    initialValues={ {
                        ...this.state.block,
                        ...this.state.video,
                    } } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
BlockWizard.defaultProps = {
    visible: false,
    onSubmit: () => { return Promise.resolve(); },
};

export default BlockWizard;
